import React, { useCallback } from 'react'
import { Space } from '@mantine/core'
import { Button } from '@wove/web-ui'
import { useNavigate } from 'react-router-dom'

const SuccessScreen = () => {
  const navigate = useNavigate()
  const onEnter = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      navigate('/')
    },
    [navigate],
  )
  return (
    <div className="flex flex-col items-center w-full">
      <h2 className="text-xl font-medium">Boom! All Set!</h2>
      <Space h={42} />
      <Button variant="default" className="w-full max-w-[332px]" onClick={onEnter}>
        Enter Workspace
      </Button>
    </div>
  )
}

export default SuccessScreen
